import { Helmet } from 'react-helmet';
import { getCanonicalUrl, getBaseUrl } from '../utils/config';

const SEO = ({ 
  title = "Vithminds Technologies - AI-Powered Digital Transformation",
  description = "Vithminds delivers AI-first digital transformation solutions for Fortune 500 enterprises. Expert consulting in AI, Low-Code/No-Code, Data Analytics, and Digital Ecosystem Services.",
  keywords = "AI solutions, digital transformation, Agentic AI, intelligent automation, software development, low-code no-code, data analytics, enterprise AI, Fortune 500 consulting",
  image = null,
  url = null,
  type = "website"
}) => {
  const siteTitle = "Vithminds Technologies";
  const fullTitle = title.includes(siteTitle) ? title : `${title} | ${siteTitle}`;
  const canonicalUrl = url || getCanonicalUrl();
  const defaultImage = image || `${getBaseUrl()}/vithminds-logo.svg`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <html lang="en" />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Vithminds Technologies Private Limited" />
      <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow" />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph Tags for Social Media */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={defaultImage} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content={siteTitle} />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={defaultImage} />
      <meta name="twitter:site" content="@vithminds" />
      <meta name="twitter:creator" content="@vithminds" />

      {/* Mobile & Responsive */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=5.0" />
      <meta name="theme-color" content="#6366f1" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="default" />
      <meta name="apple-mobile-web-app-title" content={siteTitle} />

      {/* Business Information */}
      <meta name="contact" content="info@vithminds.com" />
      <meta name="geo.region" content="IN-TG" />
      <meta name="geo.placename" content="Hyderabad" />
      <meta name="geo.position" content="17.385044;78.486671" />

      {/* Security Headers */}
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
    </Helmet>
  );
};

export default SEO;
